window.$ = window.jQuery;
$(document).ready(function () {
    if ($('.js-page-pricing').length > 0 || $('.page-template-single-service').length > 0) {
        $('.currency-switcher').on('click', function () {
            var $el = $('.currency.active', $(this));

            if ($el.hasClass('eur')) {
                $('.currency.eur').removeClass('active');
                $('.currency.pln').addClass('active');
                $('.button-bg').css('left', '50%');
                changeTableCurrency('pln');
            }

            if ($el.hasClass('pln')) {
                $('.currency.pln').removeClass('active');
                $('.currency.eur').addClass('active');
                $('.button-bg').css('left', 0);
                changeTableCurrency('euro');
            }

            function changeTableCurrency(currency) {
                $('body').find('td.price').each(function (index, item) {
                    if (currency == 'euro') {
                        $(item).html($(item).data(currency) + ' <i class="fa fa-eur"></i> ');
                        $('.current-currency-name').html('EURO');
                        $('.current-currency--in-text').html('EURO');
                    } else {
                        $(item).html($(item).data(currency) + ' <span class="currency-code--pln">PLN</a> ');
                        $('.current-currency-name').html('PLN');
                        $('.current-currency--in-text').html('PLN');
                    }
                });
            }

        });
    }

    $('#currency_choice_1, #currency_choice_mobile').change(function() {
        var currency = $(this).val();

        dataLayer.push({
            'event': "change_currency",
            'currency': currency
        });

        window.location.href = 'https://' + window.location.host + window.location.pathname + "?currency=" + currency;
    });
});